<template>
	<div id="app">
		<main >
			<!-- style="background-color: #FBAF20" -->
			<!-- <Test></Test> -->
			<v-app app id="inspire" :clipped-left="true">
				<navigation-drawer 
					v-if="authentication"
					ref="drawer" 
					v-model="drawer"  
					touchless 
					:profile="profile"
				/>
				<navbar 
					v-if="authentication"
					go-profile
					@go-profile="goToProfile()"
				/>
				<v-main 
					app
					class="primary"
					id="main"
				>
					<div
						style="height: 100%" 
						class="page-color page px-5 py-1"
						:class="{
							'rounded-bl-xl': !$vuetify.breakpoint.mobile && $route.name !== 'login',
						}">
							<router-view />
						</div>
					<!-- <snackbar ref="snackbar" /> -->
				</v-main>

				<v-snackbar
					v-model="snackbar"
					:color="snackbarColor + ' white--text'"
				>
					{{message}}

					<template v-slot:action="{ attrs }">
						<v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</template>
				</v-snackbar>
			</v-app>
		</main>
	</div>
</template>
<script type="script" lang="js">
import NavigationDrawer from './components/NavigationDrawer'
import Navbar from './components/Navbar'
import { mapState } from 'vuex'
// import Test from './components/Test'

export default {
	name: 'app',
	computed: {	
		...mapState({
			authentication: state => state.auth.authentication
		}),
		snackbarColor () {
			switch (this.snackbarState) {
			case 'info': return 'primary';
			case 'warning': return 'warning-color';
			case 'error': return 'alert-color';
			default: return 'primary';
			}
		}
	},

	components: {
		NavigationDrawer,
		Navbar
		// Test
	},

	data: () => ({
		drawer: false,
		profile: false,
		snackbar: false,
		snackbarState: null,	
		message: null
	}),

	methods: {
		// logout () {
		// 	this.$store.dispatch('auth/logout').then(() => {
		// 		this.$router.push({ name: 'login' })
		// 	})
		// }
		// toggleDark () {
		// 	this.$vuetify.theme.dark = true
		// 	localStorage.setItem('dark', '1')
		// },

		// toggleLight () {
		// 	this.$vuetify.theme.dark = false
		// 	localStorage.setItem('dark', '0')
		// }
		goToProfile () {
			this.profile = !this.profile
		}
	},

	mounted () {
		// EventBus.$on('notification', e => this.$refs.snackbar.show(e))
	},

	created () {
		console.log(localStorage.getItem('dark'))
		if (!localStorage.getItem('dark')) {
			if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
				this.$vuetify.theme.dark = true
			} else {
				this.$vuetify.theme.dark = false
			}
		} else {
			this.$vuetify.theme.dark = JSON.parse(localStorage.getItem('dark'))
		}
		this.$eventBus.$on('show-snackbar', (message, state = 'info') => {
			// this.message = message;
			this.message = 'Something went wrong'
			this.snackbarState = state;
			this.snackbar = true;
		});
	}
}
</script>

<style lang="scss">
@import '@beetronix/bee-components/lib/css/index.css';

input:-webkit-autofill,
input:-webkit-autofill:hover
  input:-webkit-autofill:focus
  input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #424242 inset !important;
  -webkit-text-fill-color: white !important;
}
.v-input--selection-controls .v-input__slot > .v-label {
	color: white
}

.hidden {
  visibility: hidden !important;
}

.visible {
  visibility: visible !important;
}
// .pace {
//   -webkit-pointer-events: none;
//   pointer-events: none;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   user-select: none;
// }
// .pace-inactive {
//   display: none;
// }
// .pace .pace-progress {
//   background: white;
//   position: fixed;
//   z-index: 2000;
//   top: 0;
//   right: 100%;
//   width: 100%;
//   height: 3px;
// }
// .pace .pace-progress-inner {
//   display: block;
//   position: absolute;
//   right: 0px;
//   width: 100px;
//   height: 100%;
//   box-shadow: 0 0 10px #e4941d, 0 0 5px #e4941d;
//   opacity: 1;
//   -webkit-transform: rotate(3deg) translate(0px, -4px);
//   -moz-transform: rotate(3deg) translate(0px, -4px);
//   -ms-transform: rotate(3deg) translate(0px, -4px);
//   -o-transform: rotate(3deg) translate(0px, -4px);
//   transform: rotate(3deg) translate(0px, -4px);
// }
// .pace .pace-activity {
//   display: block;
//   position: fixed;
//   z-index: 2000;
//   top: 15px;
//   right: 15px;
//   width: 14px;
//   height: 14px;
//   border: solid 2px transparent;
//   border-top-color: white;
//   border-left-color: white;
//   border-radius: 10px;
//   -webkit-animation: pace-spinner 400ms linear infinite;
//   -moz-animation: pace-spinner 400ms linear infinite;
//   -ms-animation: pace-spinner 400ms linear infinite;
//   -o-animation: pace-spinner 400ms linear infinite;
//   animation: pace-spinner 400ms linear infinite;
// }
// @-webkit-keyframes pace-spinner {
//   0% {
//     -webkit-transform: rotate(0deg);
//     transform: rotate(0deg);
//   }
//   100% {
//     -webkit-transform: rotate(360deg);
//     transform: rotate(360deg);
//   }
// }
// @-moz-keyframes pace-spinner {
//   0% {
//     -moz-transform: rotate(0deg);
//     transform: rotate(0deg);
//   }
//   100% {
//     -moz-transform: rotate(360deg);
//     transform: rotate(360deg);
//   }
// }
// @-o-keyframes pace-spinner {
//   0% {
//     -o-transform: rotate(0deg);
//     transform: rotate(0deg);
//   }
//   100% {
//     -o-transform: rotate(360deg);
//     transform: rotate(360deg);
//   }
// }
// @-ms-keyframes pace-spinner {
//   0% {
//     -ms-transform: rotate(0deg);
//     transform: rotate(0deg);
//   }
//   100% {
//     -ms-transform: rotate(360deg);
//     transform: rotate(360deg);
//   }
// }
// @keyframes pace-spinner {
//   0% {
//     transform: rotate(0deg);
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//     transform: rotate(360deg);
//   }
// }
.w-100 {
  width: 100%
}

.rounded {
	&-medium {
		border-radius: 13px !important;
	}
	&-tr-large {
		border-top-left-radius: 25px !important;
	}
	&-r-large {
		border-top-left-radius: 30px !important;
		border-bottom-left-radius: 30px !important;
	}
  &-br-large {
		border-bottom-left-radius: 30px !important;
	}
}

@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Paytone+One&family=Poetsen+One&family=Protest+Strike&family=Righteous&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zain:wght@200;300;400;700;800;900&display=swap');

html, body {
  font-family: 'Urbanist'
}
.v-application {
	font-family: 'Urbanist' !important;
	.title {
		font-family: 'Urbanist' !important;
	}
}
.input .v-input__control {
	border: 1px #e7e3e3 solid;
}
.input .v-text-field .v-input__control .v-input__slot {
	min-height: 36px !important;
	// border: 1px #e7e3e3 solid;
}

.v-label:not(.v-label--active) {
	transform: translateY(-3px);
}

.input .v-input__slot {
	box-shadow: none !important
} 

// .v-input__slot {
// 	box-shadow: none !important;
// }
// .zain-extralight {
//   font-family: "Zain", sans-serif;
//   font-weight: 200;
//   font-style: normal;
// }

// .zain-light {
//   font-family: "Zain", sans-serif;
//   font-weight: 300;
//   font-style: normal;
// }

.zain-regular {
  font-family: "Zain", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.zain-bold {
  font-family: "Zain", sans-serif;
  font-weight: 700;
  font-style: normal;
}

// .zain-extrabold {
//   font-family: "Zain", sans-serif;
//   font-weight: 800;
//   font-style: normal;
// }

// .zain-black {
//   font-family: "Zain", sans-serif;
//   font-weight: 900;
//   font-style: normal;
// }

#app {
  font-family: 'Urbanist';
}

h2 {
  font-family: 'Righteous';
  font-weight: 500;
}
body, html {
	font-family: 'Urbanist';
}
.Righteous-font-bold {
  font-family: 'Righteous';
  font-weight: 500;
}
.Righteous-font {
  font-family: 'Righteous';
  font-size: 300;
}
.Urbanist-font {
  font-family: 'Urbanist';
}
.fw-9 {
  font-weight: 1000;
}
.fw-bolder {
  font-weight: bolder;
}
.fw-4 {
  font-weight: 600;
}
.fw-5 {
  font-weight: 500
}
span{
  font-family: 'Urbanist';
}

.pink-light-background {
  background-color: #FBF4DA
}

.card-small-lgAndUp {
  width:70px; 
  height:65px;  
}
.card-small-mdAndDown {
  width: 100%; 
  height:40px;  
}
.line-h-1-3 {
  line-height: 1.3;
}
.line-h-1 {
  line-height: 1;
}
.fw-7 {
  font-weight: 700
}
.fs-10 {
  font-size: 10px;
}
.fs-11 {
  font-size: 11px;
}
.fs-12 {
  font-size: 12px;
}
.fs-15 {
  font-size: 15px
}
.fs-17 {
  font-size: 17px;
}
.fs-title {
  font-size: 20px
}
.fs-xl {
  font-size: 40px;
}
.reverse-icon {
	transform: scaleX(-1);
}

.h-100 {
  height: 100%;
}
$mdc-body: (
  font-family: unquote("Urbanist"),
  font-size: 18
);

$mdc-typography-styles-headline1: (
  font-family: unquote("Urbanist"),
  font-size: 102
);
$mdc-typography-styles-headline2: (
  font-family: unquote("Urbanist"),
  font-size: 64
);
$mdc-typography-styles-headline3: (
  font-family: unquote("Urbanist"),
  font-size: 51
);
$mdc-typography-styles-headline4: (
  font-family: unquote("Urbanist"),
  font-size: 36
);
$mdc-typography-styles-headline5: (
  font-family: unquote("Urbanist"),
  font-size: 25
);
$mdc-typography-styles-headline6: (
  font-family: unquote("Urbanist"),
  font-size: 21
);
$mdc-typography-styles-body1: (
  font-family: unquote("Urbanist"),
  font-size: 17
);
$mdc-typography-styles-body2: (
  font-family: unquote("Urbanist"),
  font-size: 15
);
$mdc-typography-styles-subtitle1: (
  font-family: unquote("Urbanist"),
  font-size: 17
);
$mdc-typography-styles-subtitle2: (
  font-family: unquote("Urbanist"),
  font-size: 15
);
$mdc-typography-styles-button: (
  font-family: unquote("Urbanist"),
  font-size: 15
);
$mdc-typography-styles-overline: (
  font-family: unquote("Urbanist"),
  font-size: 11
);
$mdc-typography-styles-caption: (
  font-family: unquote("Urbanist"),
  font-size: 13
);

.customClass .e-rte-content .e-content {
  /* to get the desired font on intially*/
  font-family: "Urbanist";
}

*::-webkit-scrollbar{
    height: 5px;
    width: 5px;
    background-color: #f8f8f8;
}
*::-webkit-scrollbar-thumb{
    background-color: #e9e9e9;
    border-radius: 10px;
}
.profile-btn:hover {
	background-color: transparent !important;
}
.profile-btn:focus {
	background-color: transparent !important;
}

nav.d-flex.flex-column.justify-start.rounded-2.v-navigation-drawer.v-navigation-drawer--clipped.v-navigation-drawer--fixed.v-navigation-drawer--open.theme--dark.primary {
	top: 10px !important;
}
.fs-sm {
	font-size: smaller;
}
// .loader {
//   width: 80px;
//   aspect-ratio: 1;
//   background: 
//     radial-gradient(farthest-side at top,#0000 calc(100% - 21px),lightblue calc(100% - 20px) 99%,#0000) bottom/100% 50%,
//     radial-gradient(farthest-side,lightblue 94%,#0000 ) left /20px 20px,
//     radial-gradient(farthest-side,lightblue 94%,#0000 ) right/20px 20px;
//   background-repeat: no-repeat;
//   position: relative;
// }
// .loader::before {
//   content: "";
//   position: absolute;
//   width: 20px;
//   height: 20px;
//   inset: auto 0 0;
//   margin: auto;
//   border-radius: 50%;
//   background: orange;
//   transform-origin: 50% -20px;
//   animation: l14 1s infinite cubic-bezier(0.5,623,0.5,-623);
// }

// .loader-dark {
//   width: 80px;
//   aspect-ratio: 1;
//   background: 
//     radial-gradient(farthest-side at top,#0000 calc(100% - 21px),rgb(255, 255, 255) calc(100% - 20px) 99%,#0000) bottom/100% 50%,
//     radial-gradient(farthest-side,rgb(255, 255, 255) 94%,#0000 ) left /20px 20px,
//     radial-gradient(farthest-side,rgb(255, 255, 255) 94%,#0000 ) right/20px 20px;
//   background-repeat: no-repeat;
//   position: relative;
// }
// .loader-dark::before {
//   content: "";
//   position: absolute;
//   width: 20px;
//   height: 20px;
//   inset: auto 0 0;
//   margin: auto;
//   border-radius: 50%;
//   background: rgb(70, 70, 69);
//   transform-origin: 50% -20px;
//   animation: l14 1s infinite cubic-bezier(0.5,623,0.5,-623);
// }
// @keyframes l14 { 
//  100% {transform: rotate(0.5deg)}
// }

/* loading */
.loader {
  width: 50px;
  aspect-ratio: 1;
  --c:no-repeat radial-gradient(farthest-side,#FBAF20 92%,#0000);
  background: 
    var(--c) 50%  0, 
    var(--c) 50%  100%, 
    var(--c) 100% 50%, 
    var(--c) 0    50%;
  background-size: 10px 10px;
  animation: l18 1s infinite;
  position: relative;
}
.loader::before {    
  content:"";
  position: absolute;
  inset:0;
  margin: 3px;
  background: repeating-conic-gradient(#0000 0 35deg,#FBAF20 0 90deg);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0);
  border-radius: 50%;
}

.loader-dark {
  width: 50px;
  aspect-ratio: 1;
  --c:no-repeat radial-gradient(farthest-side,#ffffff 92%,#0000);
  background: 
    var(--c) 50%  0, 
    var(--c) 50%  100%, 
    var(--c) 100% 50%, 
    var(--c) 0    50%;
  background-size: 10px 10px;
  animation: l18 1s infinite;
  position: relative;
}
.loader-dark::before {    
  content:"";
  position: absolute;
  inset:0;
  margin: 3px;
  background: repeating-conic-gradient(#0000 0 35deg,#ffffff 0 90deg);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0);
  border-radius: 50%;
}
@keyframes l18 { 
  100%{transform: rotate(.5turn)}
}
</style>
